export default function Footer() {
  return (
    <footer className="footer">
      <p>
        &copy; 2025 Would You Rather? by{" "}
        <a
          href="https://www.joannfrancisco.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Joann Francisco
        </a>
      </p>
    </footer>
  );
}
